import { StyledFlex, StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

import { ThemeColorMode } from 'src/common/enums';

export const StyledWrapper = styled.section<{ currentTheme: 'light' | 'dark' }>`
  ${({ currentTheme, theme }) => `
    background: ${currentTheme === ThemeColorMode.DARK ? theme.colors.gradientDark : theme.colors.background.disabled};
    padding: 3rem 3rem;
    border-radius: ${theme.radius.small};
    min-height: 13rem;
    margin: auto auto 3rem;
    max-width : inherit;
      `};
`;

export const StyledInnerSectionFull = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
`;

export const StyledInnerSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  &:first-child {
    flex-grow: 1.2;
  }
`;

export const StyledRightFlexSection = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 2;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    flex-basis: 100%;
    align-items: center;
  }
`;

export const StyledAvatarName = styled.a`
  margin-left: 0.6rem;
  color: ${({ theme }) => theme.colors.info.main};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
export const StyledProfileLink = styled.a`
  color: ${({ theme }) => theme.colors.info.main};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledTitle = styled.p`
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1.6rem;
  }
`;

export const StyledSubTitle = styled.p`
  text-align: center;
  margin-top: 0.8rem;
  color: ${({ theme }) => theme.colors.text.main};
  max-width: 33rem;
`;

export const StyledAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledFlexCenter = styled(StyledFlex)`
  justify-content: center;
  margin-top: 0.8rem;
  flex-grow: 1;
`;

export const StyledLoadingRectangle = styled.div`
  ${StyledLoadingPlaceholder};
  animation-duration: 0.8s;
  border-radius: 0;
  display: block;
  min-height: 13rem;
  margin-bottom: 1.5rem;
  max-width: inherit;
  margin: auto auto 3rem;
`;
